import AnimatedSection from './AnimatedSection';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: '⏱️',
      title: 'Increase Dwell Time',
      description: 'Families stay 2-3 hours longer when there\'s ongoing entertainment',
    },
    {
      icon: '🎯',
      title: 'Zero Scheduling Conflicts',
      description: 'We work around your program, not compete with it',
    },
    {
      icon: '📱',
      title: 'Instant Social Media Buzz',
      description: 'Parents share photos = free marketing for your event',
    },
    {
      icon: '👥',
      title: 'Proven Crowd Management',
      description: 'We pull families to quieter zones, reducing congestion',
    },
    {
      icon: '💰',
      title: 'All-Inclusive Pricing',
      description: 'One quote covers setup, staff, insurance, and breakdown',
    },
  ];

  return (
    <section className="py-20 bg-charcoal">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection className="text-center mb-12">
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-amber mb-2">Why Event Organizers Choose Us</p>
          <h2 className="text-4xl md:text-5xl font-display text-cream">
            Built For <span className="text-amber">Event Success</span>
          </h2>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <AnimatedSection key={index} delay={index * 0.1}>
              <div className="bg-charcoal-700 rounded-xl p-6 border border-amber/20 hover:border-amber/40 transition-all hover:shadow-amber-glow">
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-display text-cream mb-2">{benefit.title}</h3>
                <p className="text-cream/60">{benefit.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
